export enum SalesOrganization {
    MA = "MA",
    ME = "ME",
    MS = "MS",
    RP = "RP",
}
